import React, { useState, useEffect } from "react";
import { ReactComponent as CartSvg } from "../logo/Cart.svg";

import './PoiPage.css';
import './AddToCartButton.css';
import { useAlert } from "react-alert";
import { useSelector } from "react-redux";
import { post } from "../common/api";
import { stringToBoolean } from "../common/utils";
import axios from "axios";

export function AddToCartButton(props) {
    const auth = useSelector((state) => state.auth);
    const alert = useAlert();
    const [isLoading, setIsLoading] = useState(false);
    let [isCart, setIsCart] = useState(false);
    const Trips_id = props.id;

    useEffect(() => {
        const source = axios.CancelToken.source();
        const checkCart = async () => {
            try {
                setIsLoading(true);
                const res = await post(
                    "/api/cart/check",
                    { Trips_id },
                    {
                        headers: {
                            Authorization: `Token ${auth.token}`,
                        },
                        cancelToken: source.token,
                    }
                );
                const { message } = res.data;
                setIsCart(stringToBoolean(message));
            } catch (e) {
                console.error(e);
            }
            setIsLoading(false);
        };
        if (auth.token) {
            checkCart();
        }
        return () => {
            source.cancel();
        };
    }, [auth, Trips_id]);

    const onAdd = async () => {
        setIsLoading(true);
        try { await post( "/api/cart/add",
            { Trips_id: props.id, type: props.type },
            { headers: {Authorization: `Token ${auth.token}`} } )
            setIsCart(true);
            alert.success(`Sukses menambahkan Itinerary ${props.name} ke Keranjang`);
        } catch (e) {
            const message = e.response?.data?.message || "Terjadi suatu kesalahan, silahkan coba lagi.";
            alert.error(message);
        }
        setIsLoading(false);
    }

    if (isLoading) {
        return (
            <div className="d-flex justify-content-center
            align-self-center align-items-center w-100 h-100">
                <div className="spinner-border" role="status" />
            </div>
        );
    }
    return (
        <button className="poi-action-button primary-button"
        onClick={onAdd}
        disabled={isLoading || isCart}>
            <CartSvg />
            { isCart ? <span>ITIN ada di Keranjang</span> :
            <span>Tambah ke Keranjang</span> }
        </button>
    );
}
